import { NgOptimizedImage } from '@angular/common';
import { Component, DestroyRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ImagesConfig } from '@frontend/sports/common/client-config-data-access';
import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { ThemeElevated } from '@frontend/sports/common/ui/shared';
import { CardThemeSurface } from '@frontend/sports/common/ui/sports-themed-card';
import { VirtualSportsBannerViewModel } from '@frontend/sports/types/components/banners/models';
import { UserService } from '@frontend/sports/user/feature';
import { DsCard } from '@frontend/ui/card';
import { DsCardHeader } from '@frontend/ui/card-header';
import { combineLatest, debounceTime } from 'rxjs';

import { ArcRestrictionService } from '../arc/arc-restriction.service';
import { ImageQualityService } from '../common/image-quality.service';
import { VymlGamesModel } from './banner.model';
import { CrossSaleTracking } from './cross-sale-tracking.model';
import { VymlService } from './vyml.service';

@Component({
    selector: 'ms-vyml',
    templateUrl: './vyml.component.html',
    imports: [ScrollAdapterComponent, NgOptimizedImage, DsCard, DsCardHeader],
    styleUrl: './vyml.component.scss',
})
export class VymlComponent implements OnInit {
    @Input() model: VirtualSportsBannerViewModel;
    @Input() position = '';
    @Input() pageName = '';
    @Output() bannerDataLoaded = new EventEmitter<boolean>();

    @HostBinding('class') className = 'banner-games';

    @HostBinding('class.hidden') get hidden(): boolean {
        return !this.virtualSports?.length;
    }

    themedSurface: CardThemeSurface;

    themeElevated: ThemeElevated = {
        'sportingbet-br': { isElevated: false },
        'betboo-br': { isElevated: false },
    };
    virtualSports: VymlGamesModel[] = [];
    @ViewChild(ScrollAdapterComponent) scrollAdapter: ScrollAdapterComponent;

    private readonly destroyRef = inject(DestroyRef);

    private userService = inject(UserService);
    private vymlService = inject(VymlService);
    private arcRestrictionService = inject(ArcRestrictionService);
    private imagesConfig = inject(ImagesConfig);
    private imageQualityService = inject(ImageQualityService);

    ngOnInit(): void {
        this.themedSurface = {
            'mgm-dice': 'low',
        };
        this.getGameList();
        combineLatest([this.arcRestrictionService.gamingCrossSellEnabled$, this.userService.onUserLogInWithSettings$])
            .pipe(debounceTime(20), takeUntilDestroyed(this.destroyRef))
            .subscribe(([gamingCrossSellEnabled]) => {
                this.virtualSports = [];
                if (!gamingCrossSellEnabled) {
                    this.getGameList();
                }
            });
    }

    onSportClick(virtualSport: VymlGamesModel): void {
        this.vymlService.open(virtualSport, CrossSaleTracking.GameSectionVyml, {
            position: this.position,
            pageName: this.pageName,
        });
    }

    private getGameList(): void {
        this.vymlService.get(80).subscribe((games) => {
            this.virtualSports = games;

            if (this.virtualSports?.length > 0 && this.imagesConfig.imageQualityParams?.homePage?.vyml) {
                this.virtualSports.forEach((img) => {
                    img.imageSrc = this.imageQualityService.setImageQuality(img.imageSrc, this.imagesConfig.imageQualityParams.homePage.vyml);
                });
                this.bannerDataLoaded.emit(true);
            } else {
                this.bannerDataLoaded.emit(false);
            }
        });
    }
}
